import { Box, CardContent, Grid, Skeleton, Stack, Tabs , Tab, Button} from "@mui/material"
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ProgramCardSkeleton from '../components/programcard/ProgramCardSkeleton'
import ProgramCard from '../components/programcard/ProgramCard'
import BundleCard from '../components/bundlecard/bundlecard'
import { useAllPrograms } from '../hooks/useAllPrograms'
import NoDataComponent from "../components/nodata/nodata";
import { getString } from "../functions/getString";
import { useRouter } from "next/router";
import { useTheme } from "@emotion/react";

const SkeletonData = () =>{
    return(
        <Box>
            <Skeleton variant="rectangular" width={'100%'} height={150}/> 
            <Skeleton variant="rectangular" width={'100%'} height={12} sx={{mt:3, borderRadius:0.5}}/> 
            <Skeleton variant="rectangular" width={'70%'} height={12} sx={{mt:3, borderRadius:0.5}}/> 
        </Box>
    )
}

const CustomProgramListing = ({ item, ...props }) => {

    const [allPrograms, setAllPrograms] = useState([]);
    const [isLoading, setLoading]       = useState(true);
    const [count, setCount] = useState(0)
    const [tabValue, setTabValue] = useState("courses")
    const LIMIT = 10;
    const theme = useTheme();
    const PRIMARY_MAIN = theme.palette.primary.main;


    const { reducer } = useSelector((state) => state);
    const {push} = useRouter();
    const { isSiteBuilder, headers } = reducer;

    const getAllPrograms = async () => {
        try{
            setLoading(true)
            const result = await useAllPrograms(headers, `?type=${tabValue}&limit=${LIMIT}`)
            const totalCount = result?.total_data
            setCount(totalCount);
            
            setAllPrograms(result?.data)
            setLoading(false)
        }
        catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        if(!isSiteBuilder)
        {
            setAllPrograms([])
            getAllPrograms()
        }
    }, [isSiteBuilder, tabValue]);

    const allProgramsLength = allPrograms?.length;

    return (
        <Stack {...props} >
            <Grid item xs={12} textAlign="center" mt={3}>
                <Tabs
                    value={tabValue}
                    onChange={(e, val) => setTabValue(val)}
                    TabIndicatorProps={{ style: { display: "none" } }}
                    sx={{
                            "& .MuiTabs-flexContainer": { gap: "8px", borderBottom :"1px solid #ddd",},
                            "& .MuiTab-root": {fontSize: "0.95rem",padding: "10px 20px", borderRadius: "8px 8px 0 0", color: "primary.main",},
                            "& .Mui-selected": {color: "black", border: "1px solid #ddd",borderBottom: "none", fontWeight: 600,},
                        }}
                >
                                        
                     <Tab
                        value="courses"
                        label={
                            <span
                                data-sb-label="courses"
                                contentEditable={isSiteBuilder}
                            >
                                {item?.props?.coursesLabel ?? "Courses"}
                            </span>
                        }
                    />

                    <Tab
                        value="bundles"
                        label={
                            <span
                                data-sb-label="bundles"
                                contentEditable={isSiteBuilder}
                                style={{textTransform:"none"}}
                            >
                                {item?.props?.bundlesLabel ?? "Learning paths"}
                            </span>
                        }
                    />

                </Tabs>

            </Grid>
        
            {
                isSiteBuilder && 
                <Grid container spacing={2} mt={2} >
                    {
                        Array(5).fill(1).map((item,index) =>{
                            return(
                                <Grid item xl={2.4} lg={3} md={4} sm={6} xs={12}  key={index}>
                                    <ProgramCardSkeleton/>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            }
            { isLoading && !isSiteBuilder &&
                <Grid container  spacing={3} mb={5} >
                    {
                        Array(15). fill(1).map((item) =>{
                            return(
                                <Grid item xl={2.4} lg={2.4} md={4} sm={6} xs={12} gap={4} mt={2} >
                                    <SkeletonData/>
                                </Grid>
                            )
                        })
                    }
                </Grid>
            }

            {
                !isLoading && allProgramsLength < 1 &&                
            
                <Stack height={'30vh'} width={'100%'} alignItems={'center'} justifyContent={'center'} >
                    <NoDataComponent
                        title={getString('No courses found')}
                        description={`${getString('No courses found')}`}
                        sx={{
                            height: '60vh',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    />
                </Stack>
            }

            

            {
                !isSiteBuilder && allProgramsLength > 0 &&

                <Grid container spacing={2} mt={1} >
                    
                    {
                        allPrograms?.map((item, index) => {                           
                            return (                                           
                                <Grid item={true} xl={2.4} lg={3} md={4} sm={6} xs={6} key={index} mt={2}>
                                    {
                                        item?.pb_type == 1 || item?.pb_type == 3? 
                                        (
                                            <ProgramCard
                                                item={item}
                                                index={index}
                                            />
                                        )
                                        :
                                        (
                                            item?.bb_title &&
                                            <BundleCard
                                                item={item}
                                                index={index}
                                            />
                                        )
                                    }
                                </Grid>
                            )
                        })
                    }
                   
                </Grid>
                
            }
            {(isSiteBuilder || count > 10) && (
                <Grid xs={12} textAlign="center" mt={3}>
                    <Button
                        variant="outlined"
                        size="large"
                        sx={{ borderRadius: "999px", textTransform:"none"}}
                        component={isSiteBuilder ? "div" : "button"}
                        contentEditable={isSiteBuilder}
                        data-sb-label="show-more"
                        style={{
                            outline: "none",
                            cursor: isSiteBuilder ? "text" : "pointer",
                        }}

                        onClick={() => {
                            if (!isSiteBuilder) push("/all-courses");
                        }}
                    >
                        {item?.props?.showMoreLabel ?? "Show more"}
                    </Button>
                </Grid>
            )}


        </Stack>
    )
};

export default CustomProgramListing